import React from "react";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { LanguageProvider } from "./LanguageContext";

function App() {
  return (
    <LanguageProvider>
    <div style={{ background: "linear-gradient(to bottom,rgb(255, 255, 255),rgb(255, 255, 255))", minHeight: "100vh" }}>
      <Header />
      <About />
      <Skills />
      <Experience />
      <Footer />
    </div>
    </LanguageProvider>
  );
}

export default App;
